// editable account fields
const ACCOUNT_FIELDS = [
  'active',
  'customer_id',
  'disableAutoUpgrade',
  'planId',
  'resetOnPlanChange',
  'subscriptionId',
  'visitorLimitModifier',
  'visitorLimitModifierType'
]

// editable pixel fields
const PIXEL_FIELDS = [
  'active',
  'debug',
  'init',
  'rb',
  'spaCompatibility'
]

/**
 * Build update object based on provided params
 * * @param {array} props list of allowed properties
 * @param {object} data source data object
 * @returns {object}
 */
function createUpdateObject (props, data) {
  var obj = {}
  for (var i in props) {
    var prop = props[i]
    if (data.hasOwnProperty(prop)) {
      obj[prop] = data[prop]
    }
  }
  return obj
}

export default {
  ACCOUNT_FIELDS,
  PIXEL_FIELDS,
  createUpdateObject
}



// WEBPACK FOOTER //
// ./src/components/Users/edit/edit.js